import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import {normalizeI18nLanguage} from '@constants/languages';
import i18n from './i18n';
import './index.css';
import App from './App';
import {QueryClient, QueryClientProvider} from 'react-query';
import reportWebVitals from './reportWebVitals';

Modal.setAppElement('#root');

const queryClient = new QueryClient();

const savedLanguage = localStorage.getItem('language');
if (savedLanguage) {
  i18n.changeLanguage(normalizeI18nLanguage(savedLanguage));
}

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
